import { IMAGE_CDN } from "src/redux/api/appConst";
import UploadImageModal from "../../components/ui/UploadImageModal";
import { useGalleryImages } from "../../hooks/gallery/useFetchGalleryImages";
import { Trash } from "lucide-react";
import { toast } from "react-toastify";
import { deleteImageFromGallery } from "../../api/gallery.api";
import { useQueryClient } from "@tanstack/react-query";
import { GalleryImage } from "../../types/galleryImage";

export default function ImageGalleryView() {

  const queryClient = useQueryClient();

  const { data: galleryImages = [] as GalleryImage[] } = useGalleryImages();

  const handleImageDelete = async (img: GalleryImage) => {
    if(!img) return;

    try {
      const res = await deleteImageFromGallery(img.photo_id, img.created_at, img.s3_key);

      if(res?.message.toLowerCase() === "success") {
        toast.success("Image Deleted");

        queryClient.invalidateQueries({
          queryKey: ["adm-gallery-images"],
        });
      }
    } catch (error) {
      toast.error("Failed to Delete Image");
      console.error(error);
    }
  };

  return (
    <div className="space-y-6 animate-in slide-in-from-right-4 duration-300">
      <div className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 flex justify-between items-center">
        <h3 className="text-xl font-bold text-slate-800">Media Library</h3>

        <UploadImageModal>
          <button className="bg-emerald-600 text-white px-6 py-2.5 rounded-xl font-bold hover:bg-emerald-700 transition-all active:scale-95">
            Upload Image
          </button>
        </UploadImageModal>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
        {galleryImages.map((img: GalleryImage) => (
          <div
            key={img.photo_id}
            className="group relative aspect-square bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-xl transition-all"
          >
            <img
              src={`${IMAGE_CDN}/${img.s3_key}`}
              className="w-full h-full object-cover transition-transform group-hover:scale-110 duration-500"
              alt={img.description}
            />

            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center gap-2">
              <p className="text-white text-xs">{img.description}</p>

              <button className="bg-rose-500 text-white p-3 rounded-lg text-xs font-bold" onClick={() => handleImageDelete(img)}>
                <Trash size={20} className=""/>
              </button>
            </div>
            <p className="text-sm text-emerald-600 font-semibold">{img.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
